import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import { QuickPadService_Generic } from "@signature-it/ngx-catalogue/services";
import { QuickPadDTO} from "@signature-it/ngx-catalogue/models";

@Injectable({
    providedIn: 'root'
})

export class QuickPadService extends QuickPadService_Generic {

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig) {
        super(http, restUrlsConf)
    }

    /**
     * @returns Observable<>
     */
    pollProduct(data: any) : Observable<QuickPadDTO[]> {
        return this.http.post<QuickPadDTO[]>(`${this.itemPollUrl}`, JSON.stringify(data))
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

}
